import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { DECORATOR__class_serialization_tested } from '../_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../_base/DECORATOR__class_serialization_tested_for_hash';
import { FIELD_PRIMITIVE__base_number } from './FIELD_PRIMITIVE__base_number';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD_PRIMITIVE__int extends FIELD_PRIMITIVE__base_number {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_PRIMITIVE_INT;

  /*
   * PROPERTIES
   */

  field_connectable__type() {
    return ENUM__field_connectable_type.INT;
  }

  override set_value(value_new: number) {
    if (this.multiple_of == 0) {
      this.value = value_new;
    } else {
      this.value = value_new - (value_new % this.multiple_of);
    }
  }

  /*
   * METHODS
   */

  constructor() {
    super();
  }
}
